import { Color, Flex, Icon, SectionMessage, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export const BillEInvoiceCompletedBanner = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <>
      <SectionMessage showIcon={false} variant="info">
        <Flex alignItems="center" gap={Spacing.S12}>
          <Icon color={Color.Black} icon="info" size="lg" />
          <Text>{t('bill.view.form.completed_info')}</Text>
        </Flex>
      </SectionMessage>
      <Space />
    </>
  )
}
